(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["nq-s10-motion"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nq-s10-motion')) {
  customElements.define('nq-s10-motion', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const signal = this.abort.signal;
      this.video = this.querySelector('video');
      this.button = this.querySelector('button');
      this.status = this.querySelector('[role="status"]');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.connection = navigator.connection;
      this.manual = null;
      this.visible = false;
      this.video.muted = true;
      this.button.hidden = false;
      this.update = () => {
        const playing = !this.video.paused;
        const text = playing ? this.dataset.pause : this.dataset.play;
        this.button.setAttribute('aria-pressed', String(playing));
        this.button.setAttribute('aria-label', text + ' — ' + this.video.getAttribute('aria-label'));
        this.button.querySelector('[data-motion-text]').textContent = text;
        this.button.querySelector('[data-motion-icon]').textContent = playing ? 'Ⅱ' : '▶';
        this.dataset.state = playing ? 'playing' : 'paused';
      };
      this.load = () => {
        if (this.video.getAttribute('src')) return;
        this.video.src = window.matchMedia('(max-width: 700px)').matches ? this.video.dataset.mobile : this.video.dataset.desktop;
        this.video.load();
      };
      this.allowed = () => this.manual === true || (this.manual === null && !this.motion.matches && !this.connection?.saveData);
      this.sync = () => {
        if (this.visible && !document.hidden && this.allowed()) {
          this.load();
          this.video.play().catch(this.update);
        } else {
          this.video.pause();
        }
      };
      this.button.addEventListener('click', () => {
        if (this.video.paused) {
          this.manual = true;
          this.status.hidden = true;
          if (this.video.error) this.video.removeAttribute('src');
          this.load();
          this.video.play().catch(this.update);
        } else {
          this.manual = false;
          this.video.pause();
        }
      }, { signal });
      this.video.addEventListener('play', this.update, { signal });
      this.video.addEventListener('pause', this.update, { signal });
      this.video.addEventListener('error', () => { this.status.hidden = false; this.update(); }, { signal });
      document.addEventListener('visibilitychange', this.sync, { signal });
      this.motion.addEventListener('change', this.sync, { signal });
      this.connection?.addEventListener('change', this.sync, { signal });
      if ('IntersectionObserver' in window) {
        this.near = new IntersectionObserver(entries => {
          if (entries[0].isIntersecting && this.allowed() && !document.hidden) this.load();
        }, { rootMargin: '180px' });
        this.near.observe(this);
        this.observer = new IntersectionObserver(entries => {
          this.visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.2;
          this.sync();
        }, { threshold: [0, 0.2] });
        this.observer.observe(this);
      }
      this.update();
    }
    disconnectedCallback() {
      this.video?.pause();
      this.near?.disconnect();
      this.observer?.disconnect();
      this.abort?.abort();
      this.abort = null;
    }
  });
}
  } catch(e) { console.error(e); }
})();

})();
